import ko from "knockout";
import moment from "moment";
import ViewModel from "viewModels/ViewModel";

/**
 * The DateEditorView class.
 * @class
 */
const DateEditorView = ViewModel.extend(function (dateValue) {
    const self = this;
    self.dateValue = ko.observable();
    self.dateText = ko.observable();
    self.isOpen = ko.observable(false);
    self.placeHolderText = ko.observable();
    self.hasChanged = ko.observable(false);

    const updateDateValues = function (dateValue) {
        const dateText = ko.i18n.renderString("widget.datePicker.format", {
            date: dateValue,
        });
        self.dateText(ko.i18n.formatDate(new Date(dateText)));
    };

    if (ko.isObservable(dateValue)) {
        self.dateValue = dateValue;
    } else if (dateValue) {
        self.dateValue(dateValue);
    } else {
        const todayStart = moment().startOf("day").toDate();
        self.dateValue(todayStart.toISOString());
    }

    self.computed(function () {
        updateDateValues(self.dateValue());
        if (ko.unwrap(dateValue) !== self.dateValue()) {
            self.hasChanged(true);
        }
    });
});

export default DateEditorView;
